import { render, staticRenderFns } from "./selectedathletes.vue?vue&type=template&id=34681622&"
import script from "./selectedathletes.vue?vue&type=script&lang=js&"
export * from "./selectedathletes.vue?vue&type=script&lang=js&"
import style0 from "./selectedathletes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports